import { render, staticRenderFns } from "./TabOcr.vue?vue&type=template&id=29785140&"
import script from "./TabOcr.vue?vue&type=script&lang=js&"
export * from "./TabOcr.vue?vue&type=script&lang=js&"
import style0 from "./TabOcr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29785140')) {
      api.createRecord('29785140', component.options)
    } else {
      api.reload('29785140', component.options)
    }
    module.hot.accept("./TabOcr.vue?vue&type=template&id=29785140&", function () {
      api.rerender('29785140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/TabOcr.vue"
export default component.exports